import get from 'lodash/get';
import isNumber from 'lodash/isNumber';
import {supportsDownload} from '../../core-utilities-implementation/device-services/DeviceServicesCordova';
import {getId} from '../../core-utilities/domain/ReduxUtils';
import {getDeleteErrorMessage} from '../../core-utilities/react-i18n';
import {TOAST_TYPES} from '../../forms/enums/ToastTypes';
import {isLockedStatus} from '../../projects/services/ParentStatusService';
import {TaskType} from '../../tasks/enums/TaskType';
import {getRequirementFileName} from '../utils';


RequirementsFilesHelper.$inject = [
  '$contextMenu',
  '$popup',
  '$ngRedux',
  'FileFulfillmentDomain',
  'FileDomain',
  '$toast',
  '$download',
];

/**
 * Manage the file card menu.
 * @constructor
 */
export function RequirementsFilesHelper(
  $contextMenu,
  $popup,
  $ngRedux,
  FileFulfillmentDomain,
  FileDomain,
  $toast,
  $download,
) {
  this.showFileMenu = showFileMenu;

  /**
   *
   * @param props
   * @param {TaskType} props.taskType
   * @param {Object} props.requirement
   * @param {Object} props.roleData
   * @param {Boolean} props.canAddFile
   * @param {Object} props.filePicker
   * @param {Object} model
   * @return {*}
   */
  function showFileMenu(props, model) {
    const taskId = model ? model.aTk || model.tsk : null;
    if (!taskId || !props.requirement) return;
    const reqStatus = props.requirement.status;

    const checkActions = [];
    const addAction = props.taskType === TaskType.ASSET
      ? $contextMenu.addActionByAssetTask
      : $contextMenu.addActionByTask;

    if (supportsDownload())
      addAction(checkActions, taskId, generate_DOWNLOAD_FILE(props, model));

    // if (props.canAddFile)
    //   addAction(checkActions, taskId, generate_REPLACE_FILE(props, model, reqStatus));

    if (model.currentFileAsset)
      addAction(checkActions, taskId, generate_DELETE_FLFL(props, model, reqStatus));

    return $contextMenu.showByPermission({
      titleMessageId: 'fulfillments.files.selected.context.title',
      cancelMessageId: 'defaults.context.cancel.label',
      actions: checkActions,
    });
  }

  function generate_DOWNLOAD_FILE(props, model) {
    return {
      permission: props.taskType === TaskType.ASSET ? 'asset_task_fulfillments_view' : 'task_fulfillments_view',
      action: {
        messageId: 'fulfillments.files.context.download.file.label',
        action: downloadFile.bind(null, props, model, false),
      },
    };
  }

  // TODO: rebuild replace file action: need to render uploading status in this item like the ng directive
  // function generate_REPLACE_FILE(props, model, reqStatus) {
  //   const fileAsset = get(model, 'currentFileAsset');
  //   let permission;
  //
  //   const fileStatus = fileAsset.status;
  //   const isLocked = getIsLocked(props, reqStatus, fileStatus);
  //   const isArchived = fileAsset && (fileAsset.status === 'archived' || fileAsset.isArchived);
  //
  //   if (reqStatus === 'approved') {
  //     permission = 'requirement_approval_edit';
  //   } else if (!isArchived && fileStatus === 'approved') {
  //     permission = 'requirement_approval_edit';
  //   } else {
  //     permission = 'requirement_submission_edit';
  //   }
  //
  //   if (props.taskType === TaskType.ASSET)
  //     permission = 'asset_' + permission;
  //
  //   if (isLocked)
  //     permission += '_locked';
  //
  //   return {
  //     permission,
  //     action: {messageId: 'fulfillments.files.context.replace.file.label', action: replaceCurrentFile},
  //   };
  // }

  function generate_DELETE_FLFL(props, model, reqStatus) {
    const fileAsset = get(model, 'currentFileAsset');
    let permission;

    const fileStatus = fileAsset.status;
    const isLocked = getIsLocked(props, reqStatus, fileStatus);

    if (fileStatus === 'archived' || model.currentFileAsset.isArchived) {
      permission = 'fulfillment_archived_delete';
    } else {
      permission = (reqStatus === 'approved' || fileStatus === 'approved')
        ? 'fulfillment_approval_delete'
        : 'fulfillment_submission_delete';
    }

    if (isLocked)
      permission += '_locked';

    return {
      permission: permission,
      action: {
        messageId: 'fulfillments.files.context.delete.fulfillment.label',
        action: deleteFulfillment.bind(null, model),
        important: true,
      },
    };
  }

  function getIsLocked(props, reqStatus, fileStatus) {
    if (props.taskType === TaskType.ASSET) {
      return props.roleData.projectIsLocked
        || props.roleData.assetProjectIsLocked
        || props.roleData.assetTaskIsLocked
        || isLockedStatus(reqStatus)
        || isLockedStatus(fileStatus);
    } else {
      return props.roleData.projectIsLocked
        || props.roleData.taskIsLocked
        || isLockedStatus(reqStatus)
        || isLockedStatus(fileStatus);
    }
  }

  function downloadFile(props, model, autoOpen) {
    const file = get(model, 'currentFileAsset.file');
    if (!file)
      return Promise.reject('no file');

    const name = getRequirementFileName(props.requirement, file);

    return FileDomain.getUrl(getId(file))
      .then(result => $download.promptDownload(result, name, {autoOpen}))
      .catch(e => console.error('downloadFile', e));
  }

  function deleteFulfillment(model) {
    if (!model) return;
    const fileAsset = model.currentFileAsset;

    // TODO(i18n): convert to translation id
    if (model.status === 'approved' || get(fileAsset, 'status') === 'approved') {
      return $popup
        .countdownConfirm({
          title: 'Delete Approved File',
          template: 'This file has already been approved. Are you really sure you want to delete this file?',
        })
        .then(result => result ? performDeleteFulfillment(model) : void 0);
    } else {
      return $popup
        .confirm({
          title: 'Delete File',
          template: 'Are you sure you want to delete this file?',
        })
        .then(result => result ? performDeleteFulfillment(model) : void 0);
    }
  }

  function performDeleteFulfillment(model) {
    // may want to animate it out using the progress status but offline would never resolve and should pretend to disappear anyway
    return FileFulfillmentDomain.$remove(getId(model)).catch(error => {

      let label;
      if (model && model.currentFileAsset) {
        label = model.currentFileAsset.toString();
      } else if (isNumber(get(model, 'ord'))) {
        label = `#${model.ord}`;
      }

      showDeleteErrorMessage(label, error);
    });
  }

  function showDeleteErrorMessage(label, error) {
    const messageId = getDeleteErrorMessage(error && (error.statusCode || error.status));

    $toast.showI18nMessage({
      messageId,
      messageParams: {label: label || 'this'},
      type: TOAST_TYPES.error,
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/requirements/controllers/RequirementsFilesHelper.js